import React from 'react';
import { Searchbar as Base } from 'react-native-paper';
import { useTheme } from 'react-native-paper';
import { t } from '@lingui/macro';
import { useNavigation, useRoute } from '@react-navigation/native';
import Color from 'color';
import styled from 'styled-components/native';

import Image from '@src/components/Image';
import { windowWidth } from '@src/configuration/constants';
import useSearch from '@src/hooks/useSearch';
import { i18n } from '@src/i18n';

const Searchbar = styled(Base).attrs(({ theme }) => ({
  iconColor: Color(theme.colors.placeholder).lighten(0.2).hex(),
  placeholderTextColor: Color(theme.colors.placeholder).darken(0.2).hex(),
}))`
  elevation: 0;
  min-width: ${windowWidth / 2}px;
  width: 100%;
  height: 80%;
  max-height: 50px;
  background-color: ${({ theme }) =>
    Color(theme.colors.surface).darken(0).hex()};
`;
export const ImageIcon = styled(Image)`
  width: 24px;
  height: 24px;
`;

const Component: React.FC = () => {
  const { search, setSearch } = useSearch();
  const navigation = useNavigation();
  const route = useRoute();
  const theme = useTheme();

  const handlePress = React.useCallback(() => {
    if (route.name !== 'Search') {
      navigation.navigate('Search');
    }
  }, [navigation, route.name]);

  return (
    <Searchbar
      onIconPress={handlePress}
      onSubmitEditing={handlePress}
      value={search}
      onChangeText={setSearch}
      placeholder={i18n._(t`Search...`)}
      inputStyle={{
        fontFamily: theme.fonts.regular.fontFamily,
        fontWeight: 'normal',
        fontSize: 16,
      }}
      icon={({ size, color }) => (
        <ImageIcon
          source={require('@src/assets/images/search.png')}
          style={{
            width: 24,
            height: 24,
            tintColor: theme.colors.onSurface,
          }}
        />
      )}
    />
  );
};

Component.displayName = 'SearchBar';

export default React.memo(Component);
